module.exports = __webpack_public_path__ + "img/web_question_tip_bg1_1.fe32432c.png";